import styled from 'styled-components';
import Card from 'components/Card';

// Content Grid for two column layout
export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.hidePreview ? '1fr' : '1fr 1fr')};
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

// Channel Section - Now using shared Card component
export const ChannelSection = Card;

export const ChannelTabs = styled.div`
  display: flex;
  gap: 8px;
`;

export const ChannelTab = styled.button`
  padding: 10px 20px;
  border: 1px solid
    ${(props) =>
      props.active
        ? props.theme?.colors?.primary || '#FA4616'
        : props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.2)'
        : '#E5E7EB'};
  background: ${(props) =>
    props.active ? 'rgba(250,70,22,0.1)' : 'transparent'};
  color: ${(props) =>
    props.active
      ? props.theme?.colors?.primary || '#FA4616'
      : props.theme.name === 'dark'
      ? '#E5E7EB'
      : '#6B7280'};
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;

  &:hover {
    background: ${(props) =>
      props.active ? 'rgba(250,70,22,0.15)' : 'rgba(250,70,22,0.05)'};
    border-color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
    color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  }
`;

// Compose Section - Now using shared Card component
export const ComposeSection = Card;

export const TitleInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.05)'
      : 'rgba(255,255,255,1)'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.15)'};
  border-radius: 8px;
  color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#334155')};
  font-size: 14px;
  font-family: inherit;
  transition: all 0.15s ease;
  box-sizing: border-box;
  margin-bottom: 8px;

  &::placeholder {
    color: ${(props) => (props.theme.name === 'dark' ? '#9CA3AF' : '#64748B')};
  }

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.05)'
        : 'rgba(255,255,255,1)'};
    box-shadow: ${(props) =>
      props.theme.name === 'dark'
        ? `0 0 0 1px ${props.theme?.colors?.primary || '#FA4616'}`
        : '0 0 0 3px rgba(250,70,22,0.1)'};
  }
`;

export const MessageTextarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 12px 16px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.05)'
      : 'rgba(255,255,255,1)'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.15)'};
  border-radius: 8px;
  color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#334155')};
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;
  overflow-y: auto;

  &::placeholder {
    color: ${(props) => (props.theme.name === 'dark' ? '#9CA3AF' : '#64748B')};
  }

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.05)'
        : 'rgba(255,255,255,1)'};
    box-shadow: ${(props) =>
      props.theme.name === 'dark'
        ? `0 0 0 1px ${props.theme?.colors?.primary || '#FA4616'}`
        : '0 0 0 3px rgba(250,70,22,0.1)'};
  }
`;

export const CharacterCount = styled.div`
  text-align: right;
  font-size: 14px;
  color: ${(props) => (props.theme.name === 'dark' ? '#E5E7EB' : '#6B7280')};
  margin-top: 8px;
`;

export const QuickVariables = styled.div`
  margin-top: 16px;
`;

export const VariableButton = styled.button`
  padding: 8px 12px;
  background: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(255,255,255,0.05)' : '#F9FAFB'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark' ? 'rgba(255,255,255,0.1)' : '#E5E7EB'};
  border-radius: 8px;
  color: ${(props) => (props.theme.name === 'dark' ? '#E5E7EB' : '#6B7280')};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(250, 70, 22, 0.1);
    border-color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
    color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  }
`;
